/**
 * Build the LinkedIn "Add to Profile" URL for a completed VI Sales Certification.
 *
 * Docs: https://addtoprofile.linkedin.com/  (Public URL redirect, no OAuth.)
 * Fields we pass:
 *   name            → certification title displayed on the LinkedIn card
 *   organizationName → issuer (Mercury Solutions in our case)
 *   issueYear / issueMonth → parsed from issued_at
 *   certUrl         → public verification page (QR resolves here too)
 *   certId          → short-form ID; LinkedIn shows this on the card
 */
export function buildLinkedInAddToProfileUrl({
  programName = "VI Sales Certification 2026",
  organizationName = "Mercury Solutions",
  organizationId,                 // optional — set once VI/Mercury add a real LinkedIn company page
  issuedAtIso,                    // ISO string
  certId,
  verifyUrl,
}) {
  const issued = issuedAtIso ? new Date(issuedAtIso) : new Date();
  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: programName,
    organizationName,
    issueYear: String(issued.getFullYear()),
    issueMonth: String(issued.getMonth() + 1),
  });
  if (organizationId) params.set("organizationId", String(organizationId));
  if (certId) params.set("certId", certId);
  if (verifyUrl) params.set("certUrl", verifyUrl);
  return `https://www.linkedin.com/profile/add?${params.toString()}`;
}
